import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Selection from '@simonwep/selection-js';
import useSelection from 'shared/lib/useSelection';
import { isURL } from 'validator';

import ConfirmAction from './ConfirmAction';
import Selected from './import_rss/Selected';
import InputUrl from './import_rss/InputUrl';
import Items from './import_rss/Items';
// import Template from './import_rss/Template';
import SettingsTemplateType from './import_rss/SettingsTemplateType';
import SettingsTemplateProps from './import_rss/SettingsTemplateProps';
import fetchRss from '../lib/fetchRss';
import { useDebouncedEffect  } from '../lib/debounce';

const ImportRss = (props) => {
  const storage = window.localStorage;
  const defaultImportProps = storage.getItem('md:import_rss:props');
  const [open, setOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [url, setUrl] = useState(storage.getItem('md:import_rss:url') || '');
  const [feed, setFeed] = useState();
  const [isStartFetching, setIsStartFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isProblem, setIsProblem] = useState(null);
  const [selected, setSelected] = useState(null);
  const [templateType, setTemplateType] = useState(storage.getItem('md:import_rss:type') || 'none');
  const [templateProps, setTemplateProps] = useState(defaultImportProps ? defaultImportProps.split(',') : ['title', 'link', 'content']);

  const callbackRef = useRef();
  const elmRef = useRef();

  useEffect(() => {
    window.openImportRss = (callback) => {
      setOpen(true);
      callbackRef.current = (value) => callback(value);
    }
  });

  useEffect(() => {
    setIsStartFetching(false);
    setFeed(null);
    setIsProblem(null);
    storage.setItem("md:import_rss:url", url);
  }, [url]);

  const itemsWithIds = (items) => items.map((item, index) => ({...item, id: index}));

  useDebouncedEffect(() => {
    if(isStartFetching === false) return;

    const urlRss = url.trim();
    if(!isURL(urlRss)) {
      setIsProblem(i18n.t('import_rss.wrong_url'));
      setIsLoading(false);
      setIsStartFetching(false);

      return;
    }

    setIsLoading(true);
    const [promise, abort] = fetchRss(props.url, url);
    promise
      .then((data) => {
        const items = itemsWithIds(data.items);
        setFeed({ ...data, items });
        setIsLoading(false);
        setIsProblem(null);
      })
      .catch((err) => {
        if (err.name === 'AbortError'){
          // TODO when abort request? Nothing? 🧐
          console.log('aborted')
        } else {
          setIsProblem(i18n.t('import_rss.problem'));
          setIsLoading(false);
          setIsStartFetching(false);
          // TODO error
          // add notice of error
        }
        return;
      });

    return () => abort && abort();
  }, 100, [isStartFetching]);


  const setContent = value => {
    callbackRef.current(value);
  }

  const onReject = (e) => {
    e.stopPropagation();
    callbackRef.current('');
    setOpen(false);
  }

  const htmlDecode = (value) => {
    // const elem = document.createElement('textarea');
    // elem.innerHTML = value;

    // return elem.value;
    return value.replace(/&quot;/g, "'");
  }

  const onAccept = (e) => {
    e.stopPropagation();
    if(feed) {
      // const selectedFeed = feed.items.filter(item => selected.includes(item.id));
      // const templated = selectedFeed.map(item => Template('sample', item));
      // setContent(templated.join("\n"));

      const items = elmRef.current.querySelectorAll('.import-rss__item--selected');
      const itemsHtml = [...items].map(item => htmlDecode(item.innerHTML)).join("\n");
      setContent(itemsHtml);
      setOpen(false);
    } else {
      setIsStartFetching(true);
    }

    return false;
  }

  const wrapperClasses = classNames(
    'import-rss',
    {
      'import-rss--wait': isLoading
    }
  );

  const isFeedAny = feed && feed.items && feed.items.length > 0;

  const onSelect = (id) => setSelected([id]);
  const isActive = id => selected && selected.includes(id);//(selected && selected.some( item => item.id === id ));

  const renderItem = (item, index) => {
    return (<div>{item.title}</div>);
  }

  useSelection(
    ['.import-rss__item'],
    ['.import-rss__items'],
    (items) => {
      setSelected(items);
    },
    'id',
    {
      startareas: ['.import-rss__items'],
      container: ['.import-rss__items'],
      class: 'import-rss__selection'
    }
  );

  const insertStatus = () => {
    if(feed) {
      if (selected && selected.length > 0) {
        return 'insert';
      } else {
        return 'choice';
      }
    } else {
      if(isLoading) {
        return 'loading';
      }else{
        return 'load';
      }
    }
  };

  const insertText = () => {
    switch(insertStatus()){
      case 'insert':
        return i18n.t('import_rss.insert_selected');
      case 'choice':
        return i18n.t('import_rss.select_for_insert');
      case 'load':
        return i18n.t('import_rss.load');
      case 'loading':
        return i18n.t('import_rss.loading');
      default:
        return '---';
    }
  };

  const disabled = ['choice', 'loading'].includes(insertStatus());

  const SelectAll = ({ onFinish }) => {
    const handleClick = () => {
      setSelected(feed.items.map(item => item.id ));
      onFinish();
    }

    return <button className="btn btn-link" onClick={handleClick}>{ i18n.t('import_rss.select_all') }</button>
  }

  const ClearSelection = ({ onFinish }) => {
    const handleClick = () => {
      setSelected(null);
      onFinish();
    }

    return <button className="btn btn-link" onClick={handleClick}>{ i18n.t('import_rss.reset') }</button>
  }


  const SettingInsert = () => {
    return <button className={`btn btn-primary ${showSettings ? 'active' : ''}`} onClick={() => setShowSettings(!showSettings)}>
      <i className="fa fa-gear"/>
    </button>;
  }

  const settingsClasses = classNames(
    'import-rss__settings',
    {
      'import-rss__settings--show': showSettings
    }
  );
  const settingsButtonClasses = classNames(
    'btn', 'btn-link', 'import-rss__tools-settings',
    {
      'import-rss__tools-settings--open': showSettings
    }
  );

  return (
    <div className={wrapperClasses} ref={elmRef}>
    { open &&
      <ConfirmAction
        onAccept={onAccept}
        onReject={onReject}
        textReject={ i18n.t('import_rss.cancel') }
        textAccept={insertText()}
        disabled={disabled}
      >
        {/*appendAccept={['insert', 'choice'].includes(insertStatus()) && SettingInsert}*/}
        <h3 className="import-rss__title">{ i18n.t('import_rss.title') }</h3>
        <InputUrl value={url} onChange={value => setUrl(value)}
          placeholder={ i18n.t('import_rss.placeholder_url') } error={isProblem} />
        {isFeedAny && <>
            <div className="import-rss__tools">
              <Selected count={selected ? selected.length : 0}>
                {(!selected || selected.length !== feed.items.length) && <SelectAll />}
                {(selected && selected.length) && <ClearSelection />}
              </Selected>
              <button className={settingsButtonClasses}
                      onClick={() => setShowSettings(!showSettings)}>{ i18n.t('import_rss.customize') }</button>
              <div className={settingsClasses}>
                <div className="import-rss__settings-content">
                  <div className="form-group">
                    <label>{ i18n.t('import_rss.type') }</label>
                    <SettingsTemplateType
                        value={templateType}
                        onChange={(value) => { setTemplateType(value); storage.setItem('md:import_rss:type', value); }}/>
                  </div>
                  <div className="form-group import-rss__settings-checkboxes">
                    <label>{ i18n.t('import_rss.data') }</label>
                    <SettingsTemplateProps
                        value={templateProps}
                        onChange={(value) => { setTemplateProps(value); storage.setItem('md:import_rss:props', value); }}/>
                  </div>
                </div>
              </div>
            </div>
            <Items {...feed} select={onSelect} active={isActive} template={templateType} properties={templateProps}/>
          </>
        }
        <div className="preloader" />
      </ConfirmAction>
    }
    </div>
  );
}
export default ImportRss;
